import { render, staticRenderFns } from "./reserved_btns.vue?vue&type=template&id=55374608&scoped=true&"
import script from "./reserved_btns.vue?vue&type=script&lang=js&"
export * from "./reserved_btns.vue?vue&type=script&lang=js&"
import style0 from "./reserved_btns.vue?vue&type=style&index=0&id=55374608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55374608",
  null
  
)

component.options.__file = "reserved_btns.vue"
export default component.exports